import AuthTokenStorage, {
  AuthTokenStorageValue,
} from '@spacetab-io/auth-token-storage-js';

export const authTokenStorage = new AuthTokenStorage('auth', __stage, __config.cookie_domain);

export {
  AuthTokenStorageValue,
};
